var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useApiInstance } from '@/api/index';
const CombatLogsContext = createContext(undefined);
export const CombatLogsProvider = ({ children }) => {
    const api = useApiInstance();
    const combatMapLogsApi = api.combatTrackerApiInstance.combat_map_logs;
    const [combatLogs, setCombatLogs] = useState([]);
    const fetchLogs = useCallback((combatMapId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const logs = yield combatMapLogsApi.list({ combat_map_id: combatMapId });
            setCombatLogs(logs);
        }
        catch (e) {
            console.info('Error fetching logs:', e);
        }
    }), [combatMapLogsApi]);
    const clearLogs = useCallback((combatMapId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield combatMapLogsApi.clear(combatMapId);
            setCombatLogs([]);
        }
        catch (e) {
            console.info('Error clearing logs:', e);
        }
    }), [combatMapLogsApi]);
    const addLog = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        yield combatMapLogsApi
            .create(data)
            .then((res) => {
            setCombatLogs((prev) => [...prev, res]);
        })
            .catch((e) => {
            console.info('Error adding log:', e);
        });
    }), [combatMapLogsApi]);
    const value = useMemo(() => ({ combatLogs, fetchLogs, addLog, clearLogs }), [combatLogs, fetchLogs, addLog, clearLogs]);
    return _jsx(CombatLogsContext.Provider, { value: value, children: children });
};
export const useCombatLogs = () => {
    const context = useContext(CombatLogsContext);
    if (!context) {
        throw new Error('useCombatLogs must be used within CombatLogsProvider');
    }
    return context;
};
